export default {
	methods: {
		//event calendar only takes events by the day, so events that span multiple days need to be split appropriately
		splitMultiDayEvent(start_date,start_time,end_date,sourceEvent) {
			let vm = this

			let events = []

			let startDate = vm.moment(start_date)

			let daysBetween = vm.moment(end_date).diff(startDate,"days")

			startDate.subtract(1,"days")

			for (let d = 0; d <= daysBetween ; d++) {

				let individualEvent = JSON.parse(JSON.stringify(sourceEvent))

				individualEvent.date = startDate.add(1,"days").format("YYYY-MM-DD")
				individualEvent.startDate = start_date
				individualEvent.endDate = end_date

				individualEvent.time = vm.moment(start_date + " " + start_time,"YYYY-MM-DD hh:mm A").format("h:mm A")

				delete individualEvent.duration
				
				if (d <= daysBetween-1)
					individualEvent.continuesAfter = true

				if (d > 0)
					individualEvent.startedBefore = true

				events.push(individualEvent)
			}

			return events
		},
		calcEventTypeTotals(events) {
			let vm = this

			let lessRejectedEvents = events.filter(event => event.rejected_by == 0)

			let numSickDaysUsed = lessRejectedEvents.filter(event => event.is_sickday == 1 && (event.duration_hrs == 0 || event.duration_hrs > 8)).reduce((acc,event) => {
				if (event.end) {
					let startTruncated = vm.moment(event.start).format("YYYY-MM-DD")
					let days = vm.moment(event.end).diff(vm.moment(startTruncated),'days')

					return acc+days+1
				}
				else
					return acc+1
			},0)
			
			let partialSickDayHrsUsed = lessRejectedEvents.filter(event => event.is_sickday == 1 && event.duration_hrs > 0 && event.duration_hrs < 8).reduce((acc,event) => acc+ +event.duration_hrs,0)
			
			let numPartialSickDays = lessRejectedEvents.filter(event => event.is_sickday == 1 && event.duration_hrs > 0 && event.duration_hrs < 8).reduce((acc,event) => acc + 1,0)

			let numVacationUsed = lessRejectedEvents.filter(event => this.moment(event.start).isBefore() && event.is_vacation == 1).reduce((acc,event) => {
				if (event.end) {
					let days = vm.moment(event.end).diff(vm.moment(event.start),'days')
					return acc+days+1
				}
				else
					return acc+1
			},0)
			
			let numVacationScheduled = lessRejectedEvents.filter(event => this.moment(event.start).isSameOrAfter() && event.is_vacation == 1).reduce((acc,event) => {
				if (event.end) {
					let days = vm.moment(event.end).diff(vm.moment(event.start),'days')
					return acc+days+1
				}
				else
					return acc+1
			},0)

			return {
				numSickDaysUsed,
				partialSickDayHrsUsed,
				numPartialSickDays,
				numVacationUsed,
				numVacationScheduled
			}
		},
		approveRejectVacation(event_id,approve) {
			let vm = this

			return new Promise((resolve,reject) => {

				//get event first
				vm.getJSON("Event/find/"+event_id,{},true).then(response => {
					if (response.success) {

						let payload = {
							user_id: response.data.user_id,
							id: event_id,
						}
						if (approve)
							payload.approved = 1
						else
							payload.approved = 0

						vm.postData("Event/vacation-approval",payload,true).then(postResponse => {
							if (postResponse.success) {
								if (approve)
									vm.alertSuccess("Vacation time approved")
								else
									vm.alertSuccess('Vacation time rejected. The user has been notified.')
							}
							resolve(postResponse)
						})
					}
				})
			})
		}
	}
}